import React from "react";
import map from "lodash/map";
import round from "lodash/round";
import startsWith from "lodash/startsWith";

import { getTotal, getDivisionDoc } from "util/lifterHelper";
import { Column } from "components/table/Table";
import { GetScore, Meet } from "types";
import { getWilksAndAgePoints, getWilksPoints } from "util/formulas/wilks";
import { getIpfAndAgePoints, getIpfPoints } from "util/formulas/ipf";
import { getDotsAndAgePoints, getDotsPoints } from "util/formulas/dots";
import {
  getSchwartzMaloneAndAgePoints,
  getSchwartzMalonePoints,
} from "util/formulas/schwartzMalone";
import {
  getGlossbrennerAndAgePoints,
  getGlossbrennerPoints,
} from "util/formulas/glossbrenner";
import { getReshelAndAgePoints, getReshelPoints } from "util/formulas/reshel";
import { getParaDotsPoints } from "util/formulas/paraDots";
import { getPercentOfRecordPoints } from "util/formulas/percentOfRecord";
import { getKPoints } from "util/formulas/kPoints";
import {
  getWilks2020AndAgePoints,
  getWilks2020Points,
} from "util/formulas/wilks2020";
import { getZscoreAndAgePoints, getZscorePoints } from "util/formulas/zscore";

const scoreFunctions: Record<string, GetScore> = {
  total: getTotal,
  forecastedTotal: getTotal,
  wilks: getWilksPoints,
  forecastedWilks: getWilksPoints,
  wilksAge: getWilksAndAgePoints,
  forecastedWilksAge: getWilksAndAgePoints,
  wilks2020: getWilks2020Points,
  forecastedWilks2020: getWilks2020Points,
  wilks2020Age: getWilks2020AndAgePoints,
  forecastedWilks2020Age: getWilks2020AndAgePoints,
  ipfPoints: getIpfPoints,
  forecastedIpfPoints: getIpfPoints,
  ipfAgePoints: getIpfAndAgePoints,
  forecastedIpfAgePoints: getIpfAndAgePoints,
  dotsPoints: getDotsPoints,
  forecastedDotsPoints: getDotsPoints,
  dotsAgePoints: getDotsAndAgePoints,
  forecastedDotsAgePoints: getDotsAndAgePoints,
  schwartzMalonePoints: getSchwartzMalonePoints,
  schwartzMaloneAndAgePoints: getSchwartzMaloneAndAgePoints,
  glossbrennerPoints: getGlossbrennerPoints,
  glossbrennerAndAgePoints: getGlossbrennerAndAgePoints,
  reshelPoints: getReshelPoints,
  reshelPointsAndAgePoints: getReshelAndAgePoints,
  paraDotsPoints: getParaDotsPoints,
  forecastedParaDotsPoints: getParaDotsPoints,
  percentOfRecord: getPercentOfRecordPoints,
  forecastedPercentOfRecord: getPercentOfRecordPoints,
  kPoints: getKPoints,
  zScore: getZscorePoints,
  forecastedZscore: getZscorePoints,
  zScoreAgePoints: getZscoreAndAgePoints,
  forecastedZscoreAgePoints: getZscoreAndAgePoints,
};

const ScoreCell = ({
  data,
  column,
  meet,
  style,
}: {
  data: any;
  column: Column;
  meet: Meet;
  style: React.CSSProperties & { fontSize: number };
}) => {
  const lifter = data;
  if (lifter.row === "header") {
    return (
      <div style={style} className="table-cell-inner">
        {column.label}
      </div>
    );
  } else {
    return (
      <div style={style} className="table-cell-inner">
        {map(data.divisions, (lifterDivision, index) => {
          if (!lifterDivision.divisionId) {
            return null;
          }

          const division = getDivisionDoc(lifterDivision.divisionId, meet);
          if (!division) {
            return null;
          }

          if (division.hideOnBoard) {
            return null;
          }

          const scoreFunc =
            scoreFunctions[column.key as keyof typeof scoreFunctions];

          return (
            <div
              key={`${lifterDivision.divisionId}-${index}`}
              className="cell-row"
            >
              {round(
                scoreFunc({
                  lifter,
                  division,
                  meet,
                  forecasted: startsWith(column.key, "forecasted"),
                }),
                3
              )}
            </div>
          );
        })}
      </div>
    );
  }
};

export default ScoreCell;
